import Drawer from '@mui/material/Drawer';

import { useTranslation } from "react-i18next";

import MultiCheckBox from '../MultiCheckBox';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import fr from 'date-fns/locale/fr-CA';
import en from 'date-fns/locale/en-CA';
import subDays from "date-fns/subDays";
import addDays from "date-fns/addDays";

import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const DataTableDrawer = (props) => {

  const [t] = useTranslation('common');
  const { i18n } = useTranslation('home');

  //Routes check box handling
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };


  let list = () => (
    <div
      style={{ width: "350px" }}
      role="presentation"
    >
      <h2 className="pt-2 pb-2 text-center">{t('compareperiods.filters')}</h2>

      <div className="overflow-y-scroll pt-1 ps-2" style={{ maxHeight: "90vh" }}>

        <div className="row pt-3 pb-3">
          <h3>{t('compareperiods.dates')}</h3>
        
          <b>{t('datatable.from')}</b>
          <div>
            <DatePicker
              selected={props.startDate}
              onChange={props.handleChangeStartRange}
              selectsStart
              startDate={props.startDate}
              endDate={props.endDate}
              locale={i18n.language.substring(0, 2) == 'fr' ? fr : en}
              excludeDateIntervals={[
                {
                  start: subDays(new Date('2000-01-01'), 0),
                  end: addDays(new Date('2023-07-01'), 0)
                },
                {
                  start: subDays(new Date(), 1),
                  end: addDays(new Date('2030-12-31'), 0)
                },
              ]}
            />
          </div>
          <b>{t('datatable.to')}</b>
          <div>
            <DatePicker
              selected={props.endDate}
              onChange={props.handleChangeEndRange}
              selectsEnd
              startDate={props.startDate}
              endDate={props.endDate}
              locale={i18n.language.substring(0, 2) == 'fr' ? fr : en}
              excludeDateIntervals={[
                {
                  start: subDays(new Date('2000-01-01'), 0),
                  end: addDays(new Date('2023-07-01'), 0)
                },
                {
                  start: subDays(new Date(), 1),
                  end: addDays(new Date('2030-12-31'), 0)
                },
              ]}
            />
          </div>
        </div>

        <div className="row pt-3 pb-3">
          <h3>{t('compareperiods.days')}</h3>
          <div className="col">
            <div type="button" className={props.service == "tous" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
              onClick={(e) => props.handleDayTypeClick(e, props.t, props.setService)} >{t('compareperiods.all')}</div>
            <div type="button" className={props.service == "se" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
              onClick={(e) => props.handleDayTypeClick(e, props.t, props.setService)} >{t('compareperiods.week')}</div>
            <div type="button" className={props.service == "fds" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
              onClick={(e) => props.handleDayTypeClick(e, props.t, props.setService)} >{t('compareperiods.weekends')}</div>
          </div>
        </div>

        <div className="row pt-3 pb-3">
          <h3>{t('compareperiods.period')}</h3>
          <div className="col">
            {['all', 'morning', 'am', 'offpeak', 'pm', 'evening'].map((buttonId) => (
              <div
                type="button"
                key={buttonId}
                className={props.period.includes(buttonId) ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                onClick={(e) => props.handleMultiPeriodClick(e, props.t, props.period, props.setPeriod, buttonId)}
              >
                {t(`compareperiods.${buttonId}`)}
              </div>
            ))}
          </div>
        </div>

        <div className="row pt-3 pb-3">
          <h3>{t('datatable.routes')}</h3>
          <MultiCheckBox
            options={props.routes.map((e) => e.route_id)}
            handleMultiRoutes={props.handleMultiRoutes}
            selectedRoutes={props.selectedRoutes}
            setSelectedRoutes={props.setSelectedRoutes}
          />
        </div>

        <div className="row pt-3 pb-3">
          <h3>{t('datatable.params')}</h3>
          <FormGroup>
            <FormControlLabel id="days" control={
              <Checkbox
                checked={props.daysChecked}
                name="days"
                color="primary"
              />}
              label={t('datatable.days')}
              onChange={(e) => props.handleParams(e)} />
            <FormControlLabel id="period" control={
              <Checkbox
                checked={props.periodChecked}
                name="period"
                color="primary"
              />}
              label={t('datatable.period')}
              onChange={(e) => props.handleParams(e)} />
            <FormControlLabel id="route" control={
              <Checkbox
                checked={props.routeChecked}
                name="route"
                color="primary"
              />}
              label={t('datatable.route')}
              onChange={(e) => props.handleParams(e)} />
            <FormControlLabel id="direction" control={
              <Checkbox
                checked={props.directionChecked}
                name="direction"
                color="primary"
                disabled={!props.routeChecked}
              />}
              label='Direction'
              onChange={(e) => props.handleParams(e)} />
          </FormGroup>
        </div>

        <div className="row pt-3 pb-3">
          <h3>{t('datatable.agg')}</h3>
          <div className="col">
            <div type="button" className={props.agg == "year" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
              onClick={(e) => props.handleAggType(e)} >{t('datatable.year')}</div>
            <div type="button" className={props.agg == "month" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
              onClick={(e) => props.handleAggType(e)} >{t('datatable.month')}</div>
            <div type="button" className={props.agg == "week" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
              onClick={(e) => props.handleAggType(e)} >{t('datatable.week')}</div>
            <div type="button" className={props.agg == "day" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
              onClick={(e) => props.handleAggType(e)} >{t('datatable.day')}</div>
          </div>
        </div>

        <div className="row pt-3 pb-3">
          <h3>{t('datatable.type')}</h3>
          <div className="col">
            <div type="button" className={props.dataType == "total" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
              onClick={(e) => props.handleDataType(e)} >Total</div>
            <div type="button" className={props.dataType == "avg" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
              onClick={(e) => props.handleDataType(e)} >{t('datatable.avg')}</div>
          </div>
        </div>

        {props.error == true ?
          <Stack className="pt-2 pb-2" sx={{ width: '100%' }} spacing={2}>
            <Alert severity="error">{t('compareperiods.alert')}</Alert>
          </Stack>
          : ''}

        <div className="text-center pt-3 pb-3">
          <div type="button" className="btn btn-primary me-1" onClick={props.handleFilters} >{t('datatable.extract')}</div>
        </div>

      </div>

    </div>

  );

  return (
    <Drawer anchor={'left'} open={props.open} onClose={props.toggle}>
      {list('left')}
    </Drawer>
  )

}

export default DataTableDrawer;